import React from 'react'

const Skill = (props) => {
  const getSkillLabel = (progress) => {
    if (progress >= 75) return 'Expert'
    if (progress >= 50) return 'Advanced'
    if (progress >= 25) return 'Intermediate'
    return 'Beginner'
  }

  return (
    <div className="skill mb-4">
      <div className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 items-center">
        <div className="md:col-span-7 text-left">
          <span className="text-sm md:text-base text-base-content/82">{props.skill}</span>
        </div>
        <div className="md:col-span-5 flex items-center md:justify-end">
          <span className="skill-label inline-flex rounded-full border border-primary/15 bg-primary/8 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-primary md:text-sm">{getSkillLabel(props.progress)}</span>
        </div>
      </div>
    </div>
  )
}

export default Skill
